


















import { defineComponent, computed, toRef } from '@vue/composition-api';
import injector from 'vue-html-injector/main.vue';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';

interface PropsInterface {
    uid: number;
    content: string;
    url: string;
}

export default defineComponent({
    name: 'VehicleItem',
    components: { injector },
    props: {
        uid: { type: Number, required: true },
        content: { type: String, default: '' },
        url: { type: String, default: '' }
    },
    setup (props: PropsInterface) {
        const store = useStore();
        function isItemComparing (itemId: number): boolean {
            return store.getters.isItemComparing(+itemId);
        }
        function isDisabled (itemId: number): string {
            if (isItemComparing(itemId)) {
                return '';
            }
            return store.getters.isComparingListFull
                ? 'disabled'
                : '';
        }
        function deleteItem (itemId: number): void {
            store.dispatch(ActionTypes.DeleteItem, +itemId);
        }
        function comparingAction (itemId: number): void {
            if (isDisabled(itemId)) {
                return;
            }
            isItemComparing(itemId)
                ? store.dispatch(ActionTypes.UntickItem, +itemId)
                : store.dispatch(ActionTypes.TickItemToCompare, +itemId);
        }
        function getCheckBox (itemId: number): string {
            return isItemComparing(itemId)
                ? 'glyphicon-checkbox--checked'
                : '';
        }

        const id = toRef(props, 'uid');
        const compareCaption = computed(() => isItemComparing(id.value) ? 'Comparing' : 'Compare');
        return { deleteItem, comparingAction, isItemComparing, getCheckBox, isDisabled, compareCaption };
    }
});
